// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * IMS Management API
 * Management API for the IMS catalog: partitions, isolation units, and clusters, returned in a Kubernetes-familiar metadata/spec/status envelope (ADR-0008).
 *
 * The version of the OpenAPI document: 1.0
 * Contact: team-aura-infra@neotechnology.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import * as runtime from '../runtime';
import type {
  ApiError,
  ClusterDiscoveryTopology,
  ClusterEntity,
  ClusterList,
  ClusterStatusPatch,
  CreateCluster,
  UpdateClusterSpec,
} from '../models/index';
import {
  ApiErrorFromJSON,
  ApiErrorToJSON,
  ClusterDiscoveryTopologyFromJSON,
  ClusterDiscoveryTopologyToJSON,
  ClusterEntityFromJSON,
  ClusterEntityToJSON,
  ClusterListFromJSON,
  ClusterListToJSON,
  ClusterStatusPatchFromJSON,
  ClusterStatusPatchToJSON,
  CreateClusterFromJSON,
  CreateClusterToJSON,
  UpdateClusterSpecFromJSON,
  UpdateClusterSpecToJSON,
} from '../models/index';

export interface V1ClustersIdDeleteRequest {
  id: string;
}

export interface V1ClustersIdGetRequest {
  id: string;
}

export interface V1ClustersIdPutRequest {
  id: string;
  updateClusterSpec: UpdateClusterSpec;
}

export interface V1ClustersIdStatusPatchRequest {
  id: string;
  clusterStatusPatch: ClusterStatusPatch;
}

export interface V1ClustersIdTopologyGetRequest {
  id: string;
}

export interface V1EnvironmentsEnvironmentClustersByNameNameGetRequest {
  environment: string;
  name: string;
}

export interface V1EnvironmentsEnvironmentClustersGetRequest {
  environment: string;
  cloudProvider?: V1EnvironmentsEnvironmentClustersGetCloudProviderEnum;
  isolationUnitId?: string;
  partitionId?: string;
  role?: string;
}

export interface V1EnvironmentsEnvironmentClustersPostRequest {
  environment: string;
  createCluster: CreateCluster;
}

/**
 *
 */
export class ClustersApi extends runtime.BaseAPI {
  /**
   * Delete a cluster
   */
  async v1ClustersIdDeleteRaw(
    requestParameters: V1ClustersIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<void>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1ClustersIdDelete().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/clusters/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'DELETE',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.VoidApiResponse(response);
  }

  /**
   * Delete a cluster
   */
  async v1ClustersIdDelete(
    requestParameters: V1ClustersIdDeleteRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<void> {
    await this.v1ClustersIdDeleteRaw(requestParameters, initOverrides);
  }

  /**
   * Get a cluster
   */
  async v1ClustersIdGetRaw(
    requestParameters: V1ClustersIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1ClustersIdGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/clusters/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterEntityFromJSON(jsonValue),
    );
  }

  /**
   * Get a cluster
   */
  async v1ClustersIdGet(
    requestParameters: V1ClustersIdGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterEntity> {
    const response = await this.v1ClustersIdGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * PUT replaces the full spec.
   * Update a cluster\'s spec
   */
  async v1ClustersIdPutRaw(
    requestParameters: V1ClustersIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1ClustersIdPut().',
      );
    }

    if (requestParameters['updateClusterSpec'] == null) {
      throw new runtime.RequiredError(
        'updateClusterSpec',
        'Required parameter "updateClusterSpec" was null or undefined when calling v1ClustersIdPut().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/clusters/{id}`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PUT',
        headers: headerParameters,
        query: queryParameters,
        body: UpdateClusterSpecToJSON(requestParameters['updateClusterSpec']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterEntityFromJSON(jsonValue),
    );
  }

  /**
   * PUT replaces the full spec.
   * Update a cluster\'s spec
   */
  async v1ClustersIdPut(
    requestParameters: V1ClustersIdPutRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterEntity> {
    const response = await this.v1ClustersIdPutRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Observed state only (ADR-0010); reserved for automation. Conditions are upserted by type: each entry replaces the stored entry of its type and every other type is preserved; nothing is removed (ADR-0022). lastTransitionTime is set by the server when status changes. On a repository-owned cluster Schedulable is Git-owned and rejected with 400 (ADR-0019), except from escalated humans (ADR-0025); platform-owned clusters accept it from every writer. Derived types (ClusterProvisioned) are computed by IMS from other conditions on every write and rejected with 400 from every caller, escalated humans included (ADR-0028). Observed sub-objects are merged by source key; the row is written only when something changes.
   * Patch a cluster\'s status
   */
  async v1ClustersIdStatusPatchRaw(
    requestParameters: V1ClustersIdStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterEntity>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1ClustersIdStatusPatch().',
      );
    }

    if (requestParameters['clusterStatusPatch'] == null) {
      throw new runtime.RequiredError(
        'clusterStatusPatch',
        'Required parameter "clusterStatusPatch" was null or undefined when calling v1ClustersIdStatusPatch().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/clusters/{id}/status`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'PATCH',
        headers: headerParameters,
        query: queryParameters,
        body: ClusterStatusPatchToJSON(requestParameters['clusterStatusPatch']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterEntityFromJSON(jsonValue),
    );
  }

  /**
   * Observed state only (ADR-0010); reserved for automation. Conditions are upserted by type: each entry replaces the stored entry of its type and every other type is preserved; nothing is removed (ADR-0022). lastTransitionTime is set by the server when status changes. On a repository-owned cluster Schedulable is Git-owned and rejected with 400 (ADR-0019), except from escalated humans (ADR-0025); platform-owned clusters accept it from every writer. Derived types (ClusterProvisioned) are computed by IMS from other conditions on every write and rejected with 400 from every caller, escalated humans included (ADR-0028). Observed sub-objects are merged by source key; the row is written only when something changes.
   * Patch a cluster\'s status
   */
  async v1ClustersIdStatusPatch(
    requestParameters: V1ClustersIdStatusPatchRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterEntity> {
    const response = await this.v1ClustersIdStatusPatchRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Returns the partitions and clusters visible to the target cluster (ADR-0015): its own partition and cluster (Self), other clusters in the same partition (Sibling), and, when the target has the brain role, all other partitions and clusters in the environment (Other). Partition and isolation unit references are resolved to operational names and observed facts are projected from status.
   * Get the cluster-discovery topology for a target cluster
   */
  async v1ClustersIdTopologyGetRaw(
    requestParameters: V1ClustersIdTopologyGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterDiscoveryTopology>> {
    if (requestParameters['id'] == null) {
      throw new runtime.RequiredError(
        'id',
        'Required parameter "id" was null or undefined when calling v1ClustersIdTopologyGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/clusters/{id}/topology`;
    urlPath = urlPath.replace(
      `{${'id'}}`,
      encodeURIComponent(String(requestParameters['id'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterDiscoveryTopologyFromJSON(jsonValue),
    );
  }

  /**
   * Returns the partitions and clusters visible to the target cluster (ADR-0015): its own partition and cluster (Self), other clusters in the same partition (Sibling), and, when the target has the brain role, all other partitions and clusters in the environment (Other). Partition and isolation unit references are resolved to operational names and observed facts are projected from status.
   * Get the cluster-discovery topology for a target cluster
   */
  async v1ClustersIdTopologyGet(
    requestParameters: V1ClustersIdTopologyGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterDiscoveryTopology> {
    const response = await this.v1ClustersIdTopologyGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * Get a cluster by operational name
   */
  async v1EnvironmentsEnvironmentClustersByNameNameGetRaw(
    requestParameters: V1EnvironmentsEnvironmentClustersByNameNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterEntity>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentClustersByNameNameGet().',
      );
    }

    if (requestParameters['name'] == null) {
      throw new runtime.RequiredError(
        'name',
        'Required parameter "name" was null or undefined when calling v1EnvironmentsEnvironmentClustersByNameNameGet().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/clusters/by-name/{name}`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );
    urlPath = urlPath.replace(
      `{${'name'}}`,
      encodeURIComponent(String(requestParameters['name'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterEntityFromJSON(jsonValue),
    );
  }

  /**
   * Get a cluster by operational name
   */
  async v1EnvironmentsEnvironmentClustersByNameNameGet(
    requestParameters: V1EnvironmentsEnvironmentClustersByNameNameGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterEntity> {
    const response =
      await this.v1EnvironmentsEnvironmentClustersByNameNameGetRaw(
        requestParameters,
        initOverrides,
      );
    return await response.value();
  }

  /**
   * List clusters
   */
  async v1EnvironmentsEnvironmentClustersGetRaw(
    requestParameters: V1EnvironmentsEnvironmentClustersGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterList>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentClustersGet().',
      );
    }

    const queryParameters: any = {};

    if (requestParameters['cloudProvider'] != null) {
      queryParameters['cloud_provider'] = requestParameters['cloudProvider'];
    }

    if (requestParameters['isolationUnitId'] != null) {
      queryParameters['isolation_unit_id'] =
        requestParameters['isolationUnitId'];
    }

    if (requestParameters['partitionId'] != null) {
      queryParameters['partition_id'] = requestParameters['partitionId'];
    }

    if (requestParameters['role'] != null) {
      queryParameters['role'] = requestParameters['role'];
    }

    const headerParameters: runtime.HTTPHeaders = {};

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/clusters`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'GET',
        headers: headerParameters,
        query: queryParameters,
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterListFromJSON(jsonValue),
    );
  }

  /**
   * List clusters
   */
  async v1EnvironmentsEnvironmentClustersGet(
    requestParameters: V1EnvironmentsEnvironmentClustersGetRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterList> {
    const response = await this.v1EnvironmentsEnvironmentClustersGetRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }

  /**
   * IMS assigns the id and operational name (ADR-0005). The cluster starts with InfrastructureProvisioned and ComponentsProvisioned set to False with reason Pending (ADR-0026), and ClusterProvisioned derived from them as False (ADR-0028).
   * Create a cluster
   */
  async v1EnvironmentsEnvironmentClustersPostRaw(
    requestParameters: V1EnvironmentsEnvironmentClustersPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<runtime.ApiResponse<ClusterEntity>> {
    if (requestParameters['environment'] == null) {
      throw new runtime.RequiredError(
        'environment',
        'Required parameter "environment" was null or undefined when calling v1EnvironmentsEnvironmentClustersPost().',
      );
    }

    if (requestParameters['createCluster'] == null) {
      throw new runtime.RequiredError(
        'createCluster',
        'Required parameter "createCluster" was null or undefined when calling v1EnvironmentsEnvironmentClustersPost().',
      );
    }

    const queryParameters: any = {};

    const headerParameters: runtime.HTTPHeaders = {};

    headerParameters['Content-Type'] = 'application/json';

    if (this.configuration && this.configuration.apiKey) {
      headerParameters['Authorization'] =
        await this.configuration.apiKey('Authorization'); // BearerAuth authentication
    }

    let urlPath = `/v1/environments/{environment}/clusters`;
    urlPath = urlPath.replace(
      `{${'environment'}}`,
      encodeURIComponent(String(requestParameters['environment'])),
    );

    const response = await this.request(
      {
        path: urlPath,
        method: 'POST',
        headers: headerParameters,
        query: queryParameters,
        body: CreateClusterToJSON(requestParameters['createCluster']),
      },
      initOverrides,
    );

    return new runtime.JSONApiResponse(response, jsonValue =>
      ClusterEntityFromJSON(jsonValue),
    );
  }

  /**
   * IMS assigns the id and operational name (ADR-0005). The cluster starts with InfrastructureProvisioned and ComponentsProvisioned set to False with reason Pending (ADR-0026), and ClusterProvisioned derived from them as False (ADR-0028).
   * Create a cluster
   */
  async v1EnvironmentsEnvironmentClustersPost(
    requestParameters: V1EnvironmentsEnvironmentClustersPostRequest,
    initOverrides?: RequestInit | runtime.InitOverrideFunction,
  ): Promise<ClusterEntity> {
    const response = await this.v1EnvironmentsEnvironmentClustersPostRaw(
      requestParameters,
      initOverrides,
    );
    return await response.value();
  }
}

/**
 * @export
 */
export const V1EnvironmentsEnvironmentClustersGetCloudProviderEnum = {
  Gcp: 'gcp',
  Aws: 'aws',
  Azure: 'azure',
} as const;
export type V1EnvironmentsEnvironmentClustersGetCloudProviderEnum =
  (typeof V1EnvironmentsEnvironmentClustersGetCloudProviderEnum)[keyof typeof V1EnvironmentsEnvironmentClustersGetCloudProviderEnum];
